import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const FilterFunnelIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        data-testid="icon-filterFunnel"
        fill={customColour}
        className={styles[className]}
        fillRule="evenodd"
        transform="translate(0 2)"
      >
        <rect height="2" width="16" />
        <rect height="2" width="10" x="3" y="5" />
        <rect height="2" width="4" x="6" y="10" />
      </g>
    </Icon>
  )
}
